var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c("header-label", {
            attrs: {
              label: _vm.$t("packing.header"),
              "prepend-icon": "$packingHeader"
            }
          }),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v(" mdi-chevron-left ")
              ])
            ],
            1
          ),
          _c("span", { staticClass: "primary--text mb-3" }, [
            _vm._v(" " + _vm._s(_vm.$t("shopsetting.header")) + " ")
          ])
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "9" } },
                    [
                      _c("packing-toggle", {
                        attrs: {
                          text: _vm.$t("packing.enablePackedStage"),
                          state: _vm.state.enablePackedStage,
                          "text-icon": "$packageTitle"
                        },
                        on: {
                          input: function($event) {
                            return _vm.checkToggle("enablePackedStage")
                          }
                        },
                        model: {
                          value: _vm.setting.enablePackedStage,
                          callback: function($$v) {
                            _vm.$set(_vm.setting, "enablePackedStage", $$v)
                          },
                          expression: "setting.enablePackedStage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-12", attrs: { cols: "9" } },
                    [
                      _c("packing-toggle", {
                        attrs: {
                          text: _vm.$t("packing.checkProductBeforeConfirmPack"),
                          state: _vm.state.checkProductBeforeConfirmPack,
                          disable: _vm.setting.enablePackedStage
                        },
                        on: {
                          input: function($event) {
                            return _vm.checkToggle(
                              "checkProductBeforeConfirmPack"
                            )
                          }
                        },
                        model: {
                          value: _vm.setting.checkProductBeforeConfirmPack,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.setting,
                              "checkProductBeforeConfirmPack",
                              $$v
                            )
                          },
                          expression: "setting.checkProductBeforeConfirmPack"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-12", attrs: { cols: "9" } },
                    [
                      _c("packing-toggle", {
                        staticClass: "ml-12",
                        attrs: {
                          text: _vm.$t("packing.orderCheckItemAutoClick"),
                          state: _vm.state.orderCheckItemAutoClick,
                          disable: _vm.checkConfirm
                        },
                        on: {
                          input: function($event) {
                            return _vm.checkToggle("orderCheckItemAutoClick")
                          }
                        },
                        model: {
                          value: _vm.setting.orderCheckItemAutoClick,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.setting,
                              "orderCheckItemAutoClick",
                              $$v
                            )
                          },
                          expression: "setting.orderCheckItemAutoClick"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }